export default "__VITE_ASSET__ufz_Ua_V__"